<script lang="ts">
  import { browser } from '$app/environment';
  import { page } from '$app/state';

  let isWithinIframe = $derived(browser && window.top !== window.self);
</script>

{#if !isWithinIframe}
  <div class="controls">
    <div class="controls__pill">
      <a href={`/preview/disable?redirectTo=${page.url.href}`}> Exit Draft Mode </a>
    </div>
  </div>
{/if}

<style lang="scss">
  @import 'src/scss/media';

  .controls {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 32px;

    &__pill {
      padding: 12px 24px;
      transform: translateY(125%);
      transition: transform 0.3s ease;
      background: #ececec;
      cursor: pointer;
      border-radius: 1000px;
    }

    &:hover &__pill {
      transform: translateY(50%);
    }

    a {
      font-family: var(--font-family-primary);
      color: black;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
